import "../itinerary/itinerary.css";

import React, { SetStateAction, useContext, useEffect, useImperativeHandle, useState } from "react";
import { Col, Button, Modal, Row, Carousel, Form, InputGroup, Spinner } from "react-bootstrap";
import LodgingTab from "./lodging-tab/LodgingTab";
import GolfTab from "./golf-tab/GolfTab";
import TransportTab from "./transportation-tab/TransportTab";
import CustomItemTab from "./custom-items-tab/CustomItemTab";
import GetQuote from "./get-quote/GetQuote";
import MakePayment from "./make-payment/MakePayment";
import Totals from "./totals/Totals";

import Itinerary from "../../../../../Data/Itinerary";
import LodgingItineraryUnit from "../../../../../Data/Reservation/Lodging/LodgingItineraryUnit";
import GolfItineraryUnit from "../../../../../Data/Reservation/Golf/GolfItineraryUnit";
import TransportItineraryUnit from "../../../../../Data/Reservation/Transportation/TransportItineraryUnit";
import CustomItineraryUnit from "../../../../../Data/Reservation/Custom/CustomItineraryUnit";
import { DatesAndGuests } from "../../widget-form/WidgetForm";
import { WidgetContext } from "../../../../../context/WidgetContext";
import ViewPort from "../../../../../_helpers/Enums/ViewPortEnum";
import Quote from "../../../../../Data/Quote/Quote";
import Customer from "../../../../../Data/Customer/Customer";
import useCreateQuote, { CreateQuoteRequest } from "../data-service-hooks/UseCreateQuote";
import Reservation from "../../../../../Data/Reservation/Reservation";
import { ReservationCustomer } from "../../../../../Data/Reservation/ReservationCustomer";
import LodgingItinerary from "../../../../../Data/Reservation/Lodging/LodgingItinerary";
import CustomItinerary from "../../../../../Data/Reservation/Custom/CustomItinerary";
import GolfItinerary from "../../../../../Data/Reservation/Golf/GolfItinerary";
import TransportItinerary from "../../../../../Data/Reservation/Transportation/TransportItinerary";
import LodgingItem from "../../../../../Data/LodgingItem";
import CustomItem from "../../../../../Data/CustomItem";
import GolfItem from "../../../../../Data/GolfItem";
import TransportItem from "../../../../../Data/TransportItem";
import Vendor from "../../../../../Data/Vendor";
import VendorUnit from "../../../../../Data/VendorUnit";
import ItineraryUnit from "../../../../../Data/ItineraryUnit";
import moment from "moment";
import { ReservationStatus } from "../../../../../Data/Reservation/ReservationStatus";
import { toast } from "react-toastify";
import BookNow from "./book-now/BookNow";
import { Adjustment } from "../../../../../Data/Reservation/Adjustment";
import AdjustmentTab from "./adjustment-tab/AdjustmentTab";
import VendorUnitImage from "../../../../../Data/VendorUnitImage";
import ReactGA from 'react-ga4';
import UseGetPromoByName, { PromoFetchQuery, PromoFetchResponse } from "../data-service-hooks/UseGetPromoByName";
import Promo from "../../../../../Data/Promo";
import { isStringEmpty } from "../../../../../_helpers/Functions";
import { PreBuiltPkg } from "../widget-modals/pre-built-packages/Models/PreBuiltPkg";
import AddItineraryUnitButton from "./components/AddItineraryUnitButton";
import ItineraryModalButton from "./components/ItineraryModalButton";
import useCalculateWidgetHeight from "../../../../../_helpers/UseCalculateWidgetHeight";
import StartWidgetBrandSetting from "../../../../../Data/StartWidgetBrandSetting";

interface props {
  quoteState: [Quote | undefined, React.Dispatch<SetStateAction<Quote | undefined>>];
  itineraryState: [Itinerary, React.Dispatch<SetStateAction<Itinerary>>];
  showState: [string, React.Dispatch<SetStateAction<string>>];
  datesAndGuestsState: [DatesAndGuests, React.Dispatch<SetStateAction<DatesAndGuests>>];
  pbPackage: PreBuiltPkg | undefined;
  sameDayReplays: any;
  emailCustomer: ReservationCustomer | undefined;

  onEditLodging: (item: LodgingItineraryUnit) => void;
  onEditGolf: (item: GolfItineraryUnit) => void;
  onEditTransport: (item: TransportItineraryUnit) => void;
  onEditCustom: (item: CustomItineraryUnit) => void;
}

const ItineraryStart: React.FC<props> = (props) => {
  // #region logic
  const { companyId, startWidget, style, fromEmail, viewPortBreakPoint/* , brandId */, brandSettings, autoScroll, campaignId, brand } = useContext(WidgetContext);
  const brandSetting: StartWidgetBrandSetting = brandSettings.find(s => s.brandId === brand?.brandId) as StartWidgetBrandSetting;

  const {
    quoteState,
    itineraryState,
    showState,
    onEditLodging,
    onEditGolf,
    onEditTransport,
    onEditCustom,
    emailCustomer,
    pbPackage,
  } = props;

  const [quote, setQuote] = quoteState;
  const [itinerary, setItinerary] = itineraryState;
  const [show, setShow] = showState;
  const [datesAndGuests, setDatesAndGuests] = props.datesAndGuestsState;
  const [bookNowRequested, setBookNowRequested] = useState(false);
  const [quoteRequested, setQuoteRequested] = useState(false);
  const [leadCustomer, setLeadCustomer] = useState<Customer>();
  const [reservationCustomers, setReservationCustomers] = useState<ReservationCustomer[]>([]);
  const [payingCustomer, setPayingCustomer] = useState<ReservationCustomer | undefined>(emailCustomer);
  const [showModal, setShowModal] = useState<string>(payingCustomer ? "make-payment" : "");
  const [fromBooking, setFromBooking] = useState<boolean>(false);
  const [createdFromBooking, setCreatedFromBooking] = useState<boolean>(false);

  const [createRequest, setCreateRequest] = useState<CreateQuoteRequest>();
  const createResponse = useCreateQuote(createRequest);

  const [groupName, setGroupName] = useState<string | undefined>();
  const [imgIndex, setImgIndex] = useState(0);
  // const [selectedVendor, setSelectedVendor] = useState<LodgingItem | GolfItem | TransportationItem | CustomItem>();
  const [selectedVendor, setSelectedVendor] = useState<Vendor>();

  const [promoInput, setPromoInput] = useState<string>();
  const [promoRequest, setPromoRequest] = useState<PromoFetchQuery | undefined>(undefined);
  const promoFetchResponse = UseGetPromoByName(promoRequest);
  const [promo, setPromo] = useState<Promo>();
  const [promoError, setPromoError] = useState<boolean>(false);
  const [promoErrorMsg, setPromoErrorMsg] = useState<string>();

  const { sendItineraryUnitsMessage } = useCalculateWidgetHeight(
    startWidget,
    itinerary,
    autoScroll,
    show,
    showModal,
    (quote && quote.reservation.statusId && (Number)(quote.reservation.statusId) !== 40 && (Number)(quote.reservation.statusId) !== 50)
  );

  // useEffect(() => {
  //   console.log("quote", quote);
  // }, [quote]);

  const isQuoteExpired = quote === undefined ? false : (moment().isAfter(moment(quote.createdOn).add(brandSetting.quotesValidDays, "days")) && quote.reservation.statusId == 10);
  // console.log("isQuoteExpired", isQuoteExpired);

  const handleSelect = (selectedIndex: any, e: any) => {
    setImgIndex(selectedIndex);
  };

  const webViewAddButtonConditional = (!!!quote && viewPortBreakPoint > ViewPort.sm) && (pbPackage === undefined ? true : pbPackage.allowCustomization);

  function requestItineraryQuote(customers: ReservationCustomer[], groupName: string | undefined, fromBooking: boolean) {
    // call function on all tabs to set item values
    setGroupName(groupName);
    // setLeadCustomer(customer);
    setFromBooking(fromBooking);
    setReservationCustomers(customers);
    setQuoteRequested(true);
  }

  function onSaveQuote(data: Quote | undefined) {
    let quote: Quote | undefined = undefined;

    if (data) {
      toast.success("Quote has been created and sent to your email.", { hideProgressBar: false });
      quote = data;
      if (data.campaignId !== undefined) {
        if (startWidget.activateGoogleAnalytics && !isStringEmpty(startWidget.googleAnalyticsTrackingCode)) {
          ReactGA.event({
            category: "PKGLoop_Custom",
            action: "PKGLoop_Quote_Created",
            label: startWidget.brandId.toString(),
            value: quote.reservation.totalSell,
          });
        }
      }
    } else {
      toast.error("Error!", { hideProgressBar: false });
    }

    setQuote(quote !== undefined ? { ...quote } : quote);
    if (!fromBooking) {
      setShowModal("");

      if (quote !== undefined &&!window.location.href.includes("&itineraryNumber"))
      {
        window.setTimeout(() => { 
          window.location.href += `&itineraryNumber=${quote?.reservation.itineraryNumber}`;
        }, 3000);
      }
    }
    else setCreatedFromBooking(true);
  }

  function handlePromoEntry() {
    if (companyId !== undefined && !isStringEmpty(promoInput))
      setPromoRequest({
        companyId: companyId as number,
        promoCodeName: promoInput as string
      });
  }

  function handleDeletePromoEntry() {
    setPromo(undefined);
    setPromoInput("");
    setPromoError(false);
    setPromoErrorMsg(undefined);
  }

  const onReservationCustomerAdded = (reservationCustomer: ReservationCustomer) => {
    if (quote == undefined) return;

    toast.success("Guest Added!", { hideProgressBar: false });

    setTimeout(function () {
      if (!window.location.href.includes("&itineraryNumber="))
        window.location.href += `&itineraryNumber=${quote.reservation.itineraryNumber}`;
      else window.location.reload();
    }, 2000);
  }

  function displayPaymentModalForCustomer(customer: ReservationCustomer) {
    setPayingCustomer(customer);
    setShowModal("make-payment");
  }

  function removeLodgingItem(unit: LodgingItineraryUnit) {
    if (itinerary.lodgingItineraries && itinerary.lodgingItineraries.length > 0) {
      const vendorIndex = itinerary.lodgingItineraries.findIndex((i: LodgingItinerary) => i.vendorId == unit.vendorId);

      itinerary.lodgingItineraries[vendorIndex].itineraryUnits.forEach((u, i) => {
        if (itinerary.lodgingItineraries !== undefined && (unit.itineraryIndex as number) === u.itineraryIndex as number) {
          itinerary.lodgingItineraries[vendorIndex].itineraryUnits.splice(i, 1);
        }
      });

      let found = false;
      if (itinerary.lodgingItineraries.some((v: any) => v.itineraryUnits.length > 0)) found = true;
      if (!found) itinerary.lodgingItineraries = undefined;

      setItinerary({ ...itinerary });
      sendItineraryUnitsMessage();
    }
  }

  function removeGolfItem(unit: GolfItineraryUnit) {
    if (itinerary.golfItineraries && itinerary.golfItineraries.length > 0) {
      const vendorIndex = itinerary.golfItineraries.findIndex((i: GolfItinerary) => i.vendorId == unit.vendorId);

      itinerary.golfItineraries[vendorIndex].itineraryUnits.forEach((u, i) => {
        if (itinerary.golfItineraries !== undefined && (unit.itineraryIndex as number) === u.itineraryIndex as number) {
          itinerary.golfItineraries[vendorIndex].itineraryUnits.splice(i, 1);
        }
      });

      let found = false;
      if (itinerary.golfItineraries.some((v: any) => v.itineraryUnits.length > 0)) found = true;
      if (!found) itinerary.golfItineraries = undefined;

      setItinerary({ ...itinerary });
      sendItineraryUnitsMessage();
    }
  }

  function removeTransportItem(unit: TransportItineraryUnit) {
    if (itinerary.transportItineraries && itinerary.transportItineraries.length > 0) {
      const vendorIndex = itinerary.transportItineraries.findIndex((i: TransportItinerary) => i.vendorId == unit.vendorId);

      itinerary.transportItineraries[vendorIndex].itineraryUnits.forEach((u, i) => {
        if (itinerary.transportItineraries !== undefined && (unit.itineraryIndex as number) === u.itineraryIndex as number) {
          itinerary.transportItineraries[vendorIndex].itineraryUnits.splice(i, 1);
        }
      });

      let found = false;
      if (itinerary.transportItineraries.some((v: any) => v.itineraryUnits.length > 0)) found = true;
      if (!found) itinerary.transportItineraries = undefined;

      setItinerary({ ...itinerary });
      sendItineraryUnitsMessage();
    }
  }

  function removeCustomItem(unit: CustomItineraryUnit) {
    if (itinerary.customItineraries && itinerary.customItineraries.length > 0) {
      const vendorIndex = itinerary.customItineraries.findIndex((i: CustomItinerary) => i.vendorId == unit.vendorId);

      itinerary.customItineraries[vendorIndex].itineraryUnits.forEach((u, i) => {
        if (itinerary.customItineraries !== undefined && (unit.itineraryIndex as number) === u.itineraryIndex as number) {
          itinerary.customItineraries[vendorIndex].itineraryUnits.splice(i, 1);
        }
      });

      let found = false;
      if (itinerary.customItineraries.some((v: any) => v.itineraryUnits.length > 0)) found = true;
      if (!found) itinerary.customItineraries = undefined;

      setItinerary({ ...itinerary });
      sendItineraryUnitsMessage();
    }
  }

  function handleIndividualPayments(_quote: Quote) {
    setQuote({ ..._quote });
  }

  useEffect(() => {
    if (!!!promoFetchResponse.data) return;
    // if (promoFetchResponse.data) {
    const response: PromoFetchResponse = promoFetchResponse.data;
    // console.log("response", response);

    if (response && response.success && response.promo) {
      const promo = response.promo;
      // console.log("promo", promo);
      setPromoInput(promo.promoCodeName);
      let validPromo: boolean = true;

      if (promo.validToBookFor) {
        const arrive = new Date(datesAndGuests.fromDate);
        arrive.setHours(0, 0, 0, 0,);

        const depart = new Date(datesAndGuests.toDate);
        depart.setHours(0, 0, 0, 0,);

        if ((promo.validToBookForStart && (new Date(promo.validToBookForStart) > arrive)) || (promo.validToBookForEnd && (new Date(promo.validToBookForEnd) < depart))) {
          validPromo = false;
          const reason: string = "Outside of booking dates";
          setPromoError(true);
          setPromoErrorMsg(reason);
          return;
        }
      }
      else
        if (promo.validToBookFrom) {
          const today = new Date();
          if ((promo.validToBookFromStart && (new Date(promo.validToBookFromStart) > today)) || (promo.validToBookFromEnd && (new Date(promo.validToBookFromEnd) < today))) {
            validPromo = false;
            const reason: string = "Outside of usage dates";
            setPromoError(true);
            setPromoErrorMsg(reason);
            return;
          }
        }

      if (promo.promoBrands.findIndex(pb => pb.brandId === brand?.brandId) === -1) {
        validPromo = false;
      }

      // if (promo.promoVendors.length > 0
      //   // && promo.promoVendors.some(pv =>
      //   // reservationData.current.lodgingItineraries.findIndex(li => li.vendorId === pv.vendorId) === -1 &&
      //   // reservationData.current.golfItineraries.findIndex(li => li.vendorId === pv.vendorId) === -1 &&
      //   // reservationData.current.transportItineraries.findIndex(li => li.vendorId === pv.vendorId) === -1 &&
      //   // reservationData.current.customItineraries.findIndex(li => li.vendorId === pv.vendorId) === -1)
      // ) {
      //   validPromo = false;
      // }

      if (validPromo) {
        setPromo(promo);

        setPromoError(false);
        setPromoErrorMsg(undefined);

        // handleDeletePromo(); // Delete existing applied promo first

        // if (promo.discount !== undefined && promo.discount > 0) {
        //   if (promo.discountType == "%") {
        //     // let sell: number = tempAdjustmentsAndTotals.sell;
        //     // sell = sell * ((100 - promo.discount) / 100);
        //     // tempAdjustmentsAndTotals.discountApplied = tempAdjustmentsAndTotals.sell - sell;
        //     // tempAdjustmentsAndTotals.profit -= tempAdjustmentsAndTotals.discountApplied;
        //     // tempAdjustmentsAndTotals.sell = sell;
        //   }
        //   else if (promo.discountType == "$") {
        //     // tempAdjustmentsAndTotals.discountApplied = promo.discount;
        //     // tempAdjustmentsAndTotals.profit -= tempAdjustmentsAndTotals.discountApplied;
        //     // // tempAdjustmentsAndTotals.balanceDue -= promo.discount;
        //     // tempAdjustmentsAndTotals.sell -= promo.discount;
        //   }
        // }

        // setAdjustmentsAndTotals({ ...tempAdjustmentsAndTotals });
        // setRecalculateTotals(recalculateTotals + 1);
      }
      else {
        // Promo is invalid
        setPromoError(true);
        setPromoErrorMsg("Invalid promo code!");
      }
    }
    else {
      // Promo is invalid
      setPromoError(true);
      setPromoErrorMsg("Invalid promo code!");
    }
    // }
  }, [promoFetchResponse.data]);

  useEffect(() => {
    if (!bookNowRequested) return;

    setShowModal("book-now");
    setBookNowRequested(false);
  }, [bookNowRequested]);

  // #region this is what actually sends the create request
  useEffect(() => {
    if (!quoteRequested || companyId === undefined) return;
    setQuoteRequested(false);

    const tempItinerary: Itinerary = JSON.parse(JSON.stringify(itinerary));

    const li = tempItinerary.lodgingItineraries ? tempItinerary.lodgingItineraries : [];
    const gi = tempItinerary.golfItineraries ? tempItinerary.golfItineraries : [];
    const ti = tempItinerary.transportItineraries ? tempItinerary.transportItineraries : [];
    const ci = tempItinerary.customItineraries ? tempItinerary.customItineraries : [];

    let invalidDoteFound = false;
    li.forEach(i => {
      if (i.vendor !== undefined) {
        i.vendor = undefined;

        i.itineraryUnits.forEach(u => {
          u.vendor = undefined;

          if (u.sell < 0 || !u.isValid) {
            invalidDoteFound = true;
          }
        });
      }
    });
    gi.forEach(i => {
      if (i.vendor !== undefined) {
        i.vendor = undefined;

        i.itineraryUnits.forEach(u => {
          u.vendor = undefined;

          if (u.sell < 0 || !u.isValid) {
            invalidDoteFound = true;
          }
        });
      }
    });
    ti.forEach(i => {
      if (i.vendor !== undefined) {
        i.vendor = undefined;

        i.itineraryUnits.forEach(u => {
          u.vendor = undefined;

          if (u.sell < 0 || !u.isValid) {
            invalidDoteFound = true;
          }
        });
      }
    });
    ci.forEach(i => {
      if (i.vendor !== undefined) {
        i.vendor = undefined;

        i.itineraryUnits.forEach(u => {
          u.vendor = undefined;

          if (u.sell < 0 || !u.isValid) {
            invalidDoteFound = true;
          }
        });
      }
    });

    if (invalidDoteFound) {
      alert("An itinerary item contains an invalid date range.");
      return;
    }

    const reservation: Reservation = {
      companyId: companyId,
      brandId: brand?.brandId,
      leadCustomer: undefined,
      itineraryNumber: "",
      lodgingItineraries: li,
      golfItineraries: gi,
      transportItineraries: ti,
      customItineraries: ci,
      numGuests: datesAndGuests.guests,
      numChildren: 0,
      totalCost: 0.0,
      totalSell: 0.0,
      balanceDue: 0.0,
      arrive: moment(datesAndGuests.fromDate).format("YYYY-MM-DD"),
      depart: moment(datesAndGuests.toDate).format("YYYY-MM-DD"),
      tax: 0.0,
      resortFees: 0.0,
      cleaningFee: 0.0,
      promoId: promo !== undefined ? promo.promoId : undefined,
      groupName: !!!groupName ? undefined : {
        companyId: companyId,
        name: groupName
      },
      reservationCustomers: reservationCustomers,
      preBuiltPkgId: pbPackage?.preBuiltPkgId || undefined,
      isPreBuiltPkg: false
    }

    const quote: Quote = {
      reservation,
      requestNote: reservationCustomers[0].customer.customerNotes ? reservationCustomers[0].customer.customerNotes as string : "",
      campaignId: campaignId
    };

    // console.log("quote", quote);

    setCreateRequest(quote);
  }, [quoteRequested]);

  useEffect(() => {
    if (createResponse.data) {
      onSaveQuote(createResponse.data);
    }
  }, [createResponse.data]);

  useEffect(() => {
    if (createResponse.error) {
      console.log("quote error response", createResponse.error);
      onSaveQuote(undefined);
    }
  }, [createResponse.error]);

  useEffect(() => {
    // this will trigger a view height recalculation
    sendItineraryUnitsMessage();
  }, [showModal]);

  useEffect(() => {
    sendItineraryUnitsMessage();
  }, [itinerary])

  // useEffect(() => {
  //   console.log("brandSetting", brandSetting);
  // }, [brandSetting]);

  // #endregion
  return (
    <React.Fragment>
      {/* Desktop/Mobile */}
      {quote && quote.reservation && quote.reservation.deleted ? (
        <Row className="w-100 mobile-card-border mb-1">
          <Col>
            <h3 className="font-weight-bold" style={{ fontStyle: "italic", color: "red" }}>Sorry this quote is no longer valid. Please call {brandSetting?.brand.phone}</h3>
          </Col>
        </Row>
      ) : (
          <Col className=" itinerary-font mb-5">
            {!!!quote && viewPortBreakPoint < ViewPort.md && (
              <Row className="w-100 mb-3">
                {startWidget.showBookNowButton && !isQuoteExpired && (
                  <Col xs={(startWidget.showSaveQuoteButton ? 6 : 12)} className="mobile-form-buttons mt-1">
                    <Button
                      style={{
                        backgroundColor: style.bookNowButtonColor,
                        border: "none",
                        width: "100%",
                      }}
                      onClick={() => {
                        let allowLodging = true;
                        if (brandSetting !== undefined) {
                          let nights = 0;

                          if (itinerary.lodgingItineraries !== undefined) {
                            itinerary.lodgingItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                              if (!allowLodging) return;

                              const start = moment(u.startDate);
                              const end = moment(u.endDate);
                              nights = end.diff(start, "days");

                              if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber) {
                                allowLodging = false;
                              }
                            }));
                          }

                          if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber)
                            allowLodging = false;
                        }

                        let missingRate = false;;
                        let golfCount = 0;

                        if (itinerary.golfItineraries !== undefined) {
                          itinerary.golfItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                            ++golfCount;
                            if (u.availableTimes.length === 0) {
                              missingRate = true;
                            }
                          }))
                        }

                        if (!allowLodging) {
                          setShowModal("lodging-nights-required");
                          return;
                        }

                        if (missingRate) {
                          setShowModal("missing-rate");
                          return;
                        }

                        if (brandSetting.requireGolfItems && golfCount < brandSetting.golfItemsRequiredNumber) {
                          setShowModal("golf-items-required");
                          return;
                        }

                        setShowModal("book-now");
                      }}
                    >
                      Book Now
                  </Button>
                  </Col>
                )}

                {startWidget.showSaveQuoteButton && (
                  <Col xs={(startWidget.showBookNowButton ? 6 : 12)} className="mobile-form-buttons mt-1">
                    <Button
                      style={{
                        backgroundColor: style.getQuoteButtonColor,
                        border: "none",
                        width: "100%",
                      }}
                      onClick={() => {
                        let allowLodging = true;
                        if (brandSetting !== undefined) {
                          let nights = 0;

                          if (itinerary.lodgingItineraries !== undefined) {
                            itinerary.lodgingItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                              if (!allowLodging) return;

                              const start = moment(u.startDate);
                              const end = moment(u.endDate);
                              nights = end.diff(start, "days");

                              if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber) {
                                allowLodging = false;
                              }
                            }));
                          }

                          if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber)
                            allowLodging = false;
                        }

                        let missingRate = false;;
                        let golfCount = 0;

                        if (itinerary.golfItineraries !== undefined) {
                          itinerary.golfItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                            ++golfCount;
                            if (u.availableTimes.length === 0) {
                              missingRate = true;
                            }
                          }))
                        }

                        if (!allowLodging) {
                          setShowModal("lodging-nights-required");
                          return;
                        }

                        if (missingRate) {
                          setShowModal("missing-rate");
                          return;
                        }

                        if (brandSetting.requireGolfItems && golfCount < brandSetting.golfItemsRequiredNumber) {
                          setShowModal("golf-items-required");
                          return;
                        }

                        setShowModal("get-quote");
                      }}
                    >
                      Save/Get Quote
                  </Button>
                  </Col>
                )}
              </Row>
            )}

            <div className="mr-1 ml-1">
              {/* Itinerary number */}
              {quote && quote.reservation && (
                <Row className="w-100 mobile-card-border mb-1">
                  <Col>
                    <h3 className="font-weight-bold" style={{ color: style.fontColor }}>Itinerary# {quote.reservation.itineraryNumber}
                      {quote.reservation.statusId && (
                        <>
                          {quote.reservation.statusId == 20 && (
                            <span style={{ color: style.fontColor }}> - Booked <small className="font-italic" style={{ color: "red", fontSize: 14 }}>(Pending Confirmations)</small></span>
                          )}
                          {quote.reservation.statusId == 30 && (
                            <span style={{ color: style.fontColor }}> - Booked <small className="font-italic" style={{ color: "green", fontSize: 14 }}>(Complete)</small></span>
                          )}
                          {quote.reservation.statusId == 40 && (
                            <span style={{ color: style.fontColor }}> - Cancelled <small className="font-italic" style={{ color: "red", fontSize: 14 }}>(Pending Confirmations)</small></span>
                          )}
                          {quote.reservation.statusId == 50 && (
                            <span style={{ color: style.fontColor }}> - Cancelled <small className="font-italic" style={{ color: "red", fontSize: 14 }}>(Complete)</small></span>
                          )}
                          {quote.reservation.statusId == 60 && (
                            <span style={{ color: style.fontColor }}> - Booked <small className="font-italic" style={{ color: "red", fontSize: 14 }}>(Balance Due)</small></span>
                          )}
                        </>
                      )}
                    </h3>
                    <>
                      {quote.reservation.statusId && quote.reservation.statusId == 10 && isQuoteExpired && (
                        <h6 className="font-weight-bold" style={{ fontStyle: "italic", color: "red" }}>Sorry this quote is no longer valid. Please call {brandSetting.brand.phone}</h6>
                      )}
                    </>
                  </Col>
                  <Col className="d-flex flex-column justify-content-end font-weight-bold">
                    {quote.reservation.groupName && (
                      <h3 className="font-weight-bold ml-auto mr-0" style={{ color: style.fontColor }}>{quote.reservation.groupName.name}</h3>
                    )}
                    {!!!quote.reservation.groupName && quote.reservation.leadCustomer && (
                      <h3 className="font-weight-bold ml-auto mr-0" style={{ color: style.fontColor }}>
                        {quote.reservation.leadCustomer.firstName}&nbsp;{quote.reservation.leadCustomer.lastName}
                      </h3>
                    )}
                    {startWidget.showBookNowButton && viewPortBreakPoint <= ViewPort.sm && quote.reservation.statusId !== 40 && quote.reservation.statusId !== 50 && (quote.reservation.paymentCategories === undefined || quote.reservation.paymentCategories.length === 0) && (
                      <ItineraryModalButton
                        className="ml-auto mr-0 mb-2"
                        disabled={isQuoteExpired}
                        style={{
                          backgroundColor: style.bookNowButtonColor,
                          border: "none",
                          marginTop: "0px",
                          width: "130px"
                        }}
                        buttonLabel="Book Now"
                        modalString="make-payment"
                        brandSetting={brandSetting}
                        setShowModal={setShowModal}
                        itinerary={itinerary}
                      />
                    )}
                  </Col>
                </Row>
              )}

              {viewPortBreakPoint >= ViewPort.md && (
                <Row className="d-flex flex-row m-0 p-0">
                  <p style={{ color: style.fontColor }} className="itinerary-info-dates-guests m-0 p-0 mr-5"><span><i className="far fa-calendar-alt"></i></span> {datesAndGuests.fromDate ? datesAndGuests.fromDate.toDateString() : "Arrive"}</p>
                  <p style={{ color: style.fontColor }} className="itinerary-info-dates-guests m-0 p-0 mr-5"><span><i className="far fa-calendar-alt"></i></span> {datesAndGuests.toDate ? datesAndGuests.toDate.toDateString() : "Depart"}</p>
                  <p style={{ color: style.fontColor }} className="itinerary-info-dates-guests m-0 p-0"><span><i className="fas fa-user"></i></span><span className="font-weight-bold ml-1">{datesAndGuests.guests}</span>{` Guest${datesAndGuests.guests > 1 ? "s" : ""}`}</p>

                  <div className="m-0 p-0 ml-auto mr-0 d-flex flex-column">
                    {quote && quote.reservation.leadCustomer && (
                      <p className="m-0 p-0 mb-2 pt-1" style={{ color: style.fontColor }}>{quote.reservation.groupName && (<span>{quote.reservation.leadCustomer.firstName}&nbsp;{quote.reservation.leadCustomer.lastName} - </span>)}{quote.reservation.leadCustomer.emailAddress}</p>
                    )}
                    <div className="w-100 d-flex flex-row justify-content-end">
                      {!!!quote && (
                        <>
                          {startWidget.showBookNowButton && (
                            <Button
                              disabled={isQuoteExpired}
                              style={{
                                backgroundColor: style.bookNowButtonColor,
                                border: "none",
                              }}
                              onClick={() => {
                                let allowLodging = true;
                                if (brandSetting !== undefined) {
                                  let nights = 0;

                                  if (itinerary.lodgingItineraries !== undefined) {
                                    itinerary.lodgingItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                                      if (!allowLodging) return;

                                      const start = moment(u.startDate);
                                      const end = moment(u.endDate);
                                      nights = end.diff(start, "days");

                                      if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber) {
                                        allowLodging = false;
                                      }
                                    }));
                                  }

                                  if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber)
                                    allowLodging = false;
                                }

                                let missingRate = false;;
                                let golfCount = 0;

                                if (itinerary.golfItineraries !== undefined) {
                                  itinerary.golfItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                                    ++golfCount;
                                    if (u.availableTimes.length === 0) {
                                      missingRate = true;
                                    }
                                  }))
                                }

                                if (!allowLodging) {
                                  setShowModal("lodging-nights-required");
                                  return;
                                }

                                if (missingRate) {
                                  setShowModal("missing-rate");
                                  return;
                                }

                                if (brandSetting.requireGolfItems && golfCount < brandSetting.golfItemsRequiredNumber) {
                                  setShowModal("golf-items-required");
                                  return;
                                }

                                setShowModal("book-now");
                              }}
                            >
                              Book Now
                            </Button>
                          )}
                          {startWidget.showSaveQuoteButton && (
                            <Button
                              className="ml-3 mr-auto"
                              style={{
                                backgroundColor: style.getQuoteButtonColor,
                                border: "none",
                              }}
                              onClick={() => {
                                let allowLodging = true;
                                if (brandSetting !== undefined) {
                                  let nights = 0;

                                  if (itinerary.lodgingItineraries !== undefined && itinerary.lodgingItineraries !== null) {
                                    itinerary.lodgingItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                                      if (!allowLodging) return;

                                      const start = moment(u.startDate);
                                      const end = moment(u.endDate);
                                      nights = end.diff(start, "days");

                                      if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber) {
                                        allowLodging = false;
                                      }
                                    }));
                                  }

                                  if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber)
                                    allowLodging = false;
                                }

                                let missingRate = false;
                                let golfCount = 0;

                                if (itinerary.golfItineraries !== undefined && itinerary.golfItineraries !== null) {
                                  itinerary.golfItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                                    ++golfCount;
                                    if (u.availableTimes.length === 0) {
                                      missingRate = true;
                                    }
                                  }))
                                }

                                if (!allowLodging) {
                                  setShowModal("lodging-nights-required");
                                  return;
                                }

                                if (missingRate) {
                                  setShowModal("missing-rate");
                                  return;
                                }

                                if (brandSetting.requireGolfItems && golfCount < brandSetting.golfItemsRequiredNumber) {
                                  setShowModal("golf-items-required");
                                  return;
                                }

                                setShowModal("get-quote");
                              }}
                            >
                              Save/Get Quote
                            </Button>
                          )}
                        </>
                      )}

                      {quote && quote.reservation.statusId && (Number)(quote.reservation.statusId) !== 40 && (Number)(quote.reservation.statusId) !== 50 && (quote.reservation.paymentCategories === undefined || quote.reservation.paymentCategories.length === 0) && (
                        <ItineraryModalButton
                          className="ml-auto mr-0 mb-2"
                          disabled={isQuoteExpired}
                          style={{
                            border: "none",
                            marginTop: "0px",
                            width: "131px"
                          }}
                          buttonLabel={quote.quoteStatus !== undefined ? "Make Payment" : "Book Now"}
                          modalString="make-payment"
                          brandSetting={brandSetting}
                          setShowModal={setShowModal}
                          itinerary={itinerary}
                        />
                      )}
                    </div>
                  </div>
                </Row>
              )}

              {viewPortBreakPoint < ViewPort.md && (
                <Row className="d-flex flex-row">
                  <p style={{ color: style.fontColor }} className="m-0 p-0"><span className="mr-2" style={{ color: "grey" }}>Dates:</span>{datesAndGuests.fromDate ? datesAndGuests.fromDate.toDateString() : "Arrive"} - {datesAndGuests.toDate ? datesAndGuests.toDate.toDateString() : "Depart"}</p>
                </Row>
              )}

              {viewPortBreakPoint < ViewPort.md && (
                <Row className="d-flex flex-row mobile-card-border pb-3">
                  <p style={{ color: style.fontColor }} className="m-0 p-0"><span className="mr-2" style={{ color: "grey" }}>Guests:</span>{datesAndGuests.guests}</p>
                </Row>
              )}

              {/* Lodging Tab */}
              {(viewPortBreakPoint >= ViewPort.md || (itinerary.lodgingItineraries && itinerary.lodgingItineraries.some(i => i.itineraryUnits.length > 0))) && (
                <>
                  {(!!quote || startWidget.showLodgingModule) && (!fromEmail || (itinerary.lodgingItineraries && itinerary.lodgingItineraries.length > 0)) && (
                    <>
                      <div className="mt-3">
                        {(!!!quote || (itinerary.lodgingItineraries && itinerary.lodgingItineraries.some((li: LodgingItinerary) => li.itineraryUnits.some((iu: ItineraryUnit) => ((quote.reservation.statusId === ReservationStatus.CancelPending || quote.reservation.statusId === ReservationStatus.CancelComplete) && iu.showOnItinerary) || !iu.cancelled && iu.showOnItinerary)))) && (
                          <>
                            { /* if any items are showOnItinerary true then draw the header and border */}
                            <h4
                              className="itinerary-font"
                              style={{
                                color: style.headerColor,
                              }}
                            >
                              Lodging
                          </h4>

                            <Row
                              style={{
                                borderBottom: "2px solid",
                                borderColor: style.borderColor,
                              }}
                            />
                          </>
                        )}

                        {itinerary.lodgingItineraries && itinerary.lodgingItineraries.flatMap(i => i.itineraryUnits).filter(u => quote === undefined || quote.reservation.statusId === ReservationStatus.CancelPending || quote.reservation.statusId === ReservationStatus.CancelComplete || !u.cancelled)
                          .sort((a, b) => {
                            const dateA = moment(a.startDate);
                            const dateB = moment(b.endDate);

                            if (dateA.isBefore(dateB)) return -1;
                            if (dateA.isAfter(dateB)) return 1;
                            return 0;
                          })
                          .map((item: LodgingItineraryUnit, index: number) => {
                            item.itineraryIndex = index;
                            return item;
                          })
                          .map((item: LodgingItineraryUnit, index: number) => ( // test
                            <LodgingTab
                              key={`lodging tab ${item.vendorId}-${index}`}
                              itinerary={itinerary}
                              vendor={item.vendor as LodgingItem}
                              item={item}
                              itemIndex={index}
                              removeItem={removeLodgingItem}
                              editItem={(unit: LodgingItineraryUnit) => {
                                onEditLodging(unit);
                                setShow("add-lodging");
                              }}
                              bookNowRequested={bookNowRequested}
                              quoteRequested={quoteRequested}
                              datesAndGuests={datesAndGuests}
                              quoteStatus={quote && quote.reservation.statusId ? quote.reservation.statusId : undefined}
                              onVendorImageClick={(vendor: Vendor | undefined) => {
                                setSelectedVendor(vendor);
                                setShowModal("vendor-images");
                              }}
                              editable={pbPackage === undefined ? quote === undefined : quote === undefined && pbPackage.allowCustomization}
                              onCheckInDateChanged={(date) => {
                                if (itinerary.lodgingItineraries === undefined || item.itineraryIndex === undefined) return;
                                itinerary.lodgingItineraries[item.itineraryIndex].itineraryUnits[index].startDate = date;
                                setItinerary({ ...itinerary });
                              }}
                              onCheckOutDateChanged={(date) => {
                                if (itinerary.lodgingItineraries === undefined || item.itineraryIndex === undefined) return;
                                itinerary.lodgingItineraries[item.itineraryIndex].itineraryUnits[index].endDate = date;
                                setItinerary({ ...itinerary });
                              }}
                            />
                          ))}
                        {/* Add Lodging Button */}
                        {webViewAddButtonConditional && (
                          <AddItineraryUnitButton
                            buttonText="+ Add Lodging"
                            onClick={() => {
                              setShow("add-lodging");
                            }}
                          />
                        )}
                      </div>
                    </>
                  )}
                </>
              )}

              {/* Golf Tab */}
              {(viewPortBreakPoint >= ViewPort.md || (itinerary.golfItineraries && itinerary.golfItineraries.some(i => i.itineraryUnits.length > 0))) && (
                <>
                  {(!!quote || startWidget.showGolfModule) && (!fromEmail || (itinerary.golfItineraries && itinerary.golfItineraries.length > 0)) && (
                    <>
                      <div className="mt-3">
                        {(!!!quote || (itinerary.golfItineraries && itinerary.golfItineraries.some((gi: GolfItinerary) => gi.itineraryUnits.some((iu: ItineraryUnit) => ((quote.reservation.statusId === ReservationStatus.CancelPending || quote.reservation.statusId === ReservationStatus.CancelComplete) && iu.showOnItinerary) || !iu.cancelled && iu.showOnItinerary)))) && (
                          <>
                            <h4
                              className="itinerary-font"
                              style={{ color: style.headerColor }}
                            >
                              Golf
                          </h4>
                            <Row
                              style={{
                                borderBottom: "2px solid",
                                borderColor: style.borderColor,
                              }}
                            />
                          </>
                        )}

                        {/* Golf items */}
                        {itinerary.golfItineraries && itinerary.golfItineraries.flatMap(i => i.itineraryUnits).filter(u => quote === undefined || quote.reservation.statusId === ReservationStatus.CancelPending || quote.reservation.statusId === ReservationStatus.CancelComplete || !u.cancelled)
                          .sort((a, b) => {
                            const dateA = moment(a.startDate);
                            const dateB = moment(b.startDate);

                            if (dateA.isBefore(dateB)) return -1;
                            if (dateA.isAfter(dateB)) return 1;

                            if (a.startTime < b.startTime) return -1;
                            if (a.startTime > b.startTime) return 1;

                            return 0;
                          })
                          .map((item: GolfItineraryUnit, index: number) => {
                            item.itineraryIndex = index;
                            return item;
                          })
                          .map((item: GolfItineraryUnit, index: number) =>
                            //be able to add items to replays target correct array by index
                            <>
                              {/* {fromEmail && (
                  <p>FROM EMAIL</p>
                )} */}
                              {true && (
                                <GolfTab
                                  itineraryNumber={quote !== undefined && quote.reservation !== undefined ? quote.reservation.itineraryNumber as string : ""}
                                  key={`golf tab ${item.vendorId}-${index}`}
                                  itinerary={itinerary}
                                  itemIndex={index}
                                  vendor={item.vendor as GolfItem}
                                  // sameDayReplays={sameDayReplays}
                                  item={item}
                                  removeItem={removeGolfItem}
                                  editItem={(unit: GolfItineraryUnit) => {
                                    // unit.vendor.itineraryIndex = index;
                                    onEditGolf(unit);
                                    setShow("add-golf");
                                  }}
                                  bookNowRequested={bookNowRequested}
                                  quoteRequested={quoteRequested}
                                  datesAndGuests={datesAndGuests}
                                  quoteStatus={quote && quote.reservation.statusId ? quote.reservation.statusId : undefined}
                                  onVendorImageClick={(vendor: Vendor | undefined) => {
                                    setSelectedVendor(vendor);
                                    setShowModal("vendor-images");
                                  }}
                                  editable={pbPackage === undefined ? quote === undefined : quote === undefined && pbPackage.allowCustomization}
                                />
                              )}
                            </>
                          )}

                        {/* Add Golf Button */}
                        {webViewAddButtonConditional && (
                          <AddItineraryUnitButton
                            buttonText="+ Add Golf"
                            onClick={() => {
                              setShow("add-golf");
                            }}
                          />
                        )}
                      </div>
                    </>
                  )}
                </>
              )}

              {/* Transportation Tab */}
              {(viewPortBreakPoint >= ViewPort.md || (itinerary.transportItineraries && itinerary.transportItineraries.some(i => i.itineraryUnits.length > 0))) && (
                <>
                  {(!!quote || startWidget.showTransportationModule) && (!fromEmail || (itinerary.transportItineraries && itinerary.transportItineraries.length > 0)) && (
                    <>
                      <div className="mt-3">
                        {(!!!quote || (itinerary.transportItineraries && itinerary.transportItineraries.some((ti: TransportItinerary) => ti.itineraryUnits.some((iu: ItineraryUnit) => ((quote.reservation.statusId === ReservationStatus.CancelPending || quote.reservation.statusId === ReservationStatus.CancelComplete) && iu.showOnItinerary) || !iu.cancelled && iu.showOnItinerary)))) && (
                          <>
                            <h4
                              className="itinerary-font"
                              style={{ color: style.headerColor }}
                            >
                              Transportation
                          </h4>
                            <Row
                              style={{
                                borderBottom: "2px solid",
                                borderColor: style.borderColor,
                              }}
                            />
                          </>
                        )}

                        {/* Transportation items */}
                        {/* {itinerary.transportItineraries && itinerary.transportItineraries.map((transportItinerary: TransportItinerary) => transportItinerary.itineraryUnits.map((item: TransportItineraryUnit, index: number) => ( */}
                        {itinerary.transportItineraries && itinerary.transportItineraries.flatMap(i => i.itineraryUnits).filter(u => quote === undefined || quote.reservation.statusId === ReservationStatus.CancelPending || quote.reservation.statusId === ReservationStatus.CancelComplete || !u.cancelled)
                          .sort((a, b) => {
                            const dateA = moment(a.startDate);
                            const dateB = moment(b.startDate);

                            if (dateA.isBefore(dateB)) return -1;
                            if (dateA.isAfter(dateB)) return 1;

                            // if (isStringEmpty(a.startTime) || isStringEmpty(b.startTime)) return 0;

                            if (a.startTime !== undefined && b.startTime !== undefined) {
                              if (a.startTime < b.startTime) return -1;
                              if (a.startTime > b.startTime) return 1;
                            }
                            return 0;
                          })
                          .map((item: TransportItineraryUnit, index: number) => {
                            item.itineraryIndex = index;
                            return item;
                          })
                          .map((item: TransportItineraryUnit, index: number) => (
                            <TransportTab
                              key={`Transport tab ${item.vendorId}-${index}`}
                              itinerary={itinerary}
                              item={item}
                              vendor={item.vendor as TransportItem}
                              itemIndex={index}
                              removeItem={removeTransportItem}
                              editItem={(unit: TransportItineraryUnit) => {
                                // unit.vendor.itineraryIndex = index;
                                onEditTransport(unit);
                                setShow("add-transportation");
                              }}
                              bookNowRequested={bookNowRequested}
                              quoteRequested={quoteRequested}
                              datesAndGuests={datesAndGuests}
                              quoteStatus={quote && quote.reservation.statusId ? quote.reservation.statusId : undefined}
                              onVendorImageClick={(vendor: Vendor | undefined) => {
                                setSelectedVendor(vendor);
                                setShowModal("vendor-images");
                              }}
                              editable={pbPackage === undefined ? quote === undefined : quote === undefined && pbPackage.allowCustomization}
                            />
                          ))}

                        {/* Add Transportation Button */}
                        {webViewAddButtonConditional && (
                          <AddItineraryUnitButton
                            buttonText="+ Add Transportation"
                            onClick={() => {
                              setShow("add-transportation");
                            }}
                          />
                        )}
                      </div>
                    </>
                  )}
                </>
              )}

              {/* Custom Tab */}
              {(viewPortBreakPoint >= ViewPort.md || (itinerary.customItineraries && itinerary.customItineraries.some(i => i.itineraryUnits.length > 0))) && (
                <>
                  {(!!quote || startWidget.showCustomItemsModule) && (!fromEmail || (itinerary.customItineraries && itinerary.customItineraries.length > 0)) && (
                    <>
                      <div className="mt-3">
                        {(!!!quote || (itinerary.customItineraries && itinerary.customItineraries.some((ci: CustomItinerary) => ci.itineraryUnits.some((iu: ItineraryUnit) => ((quote.reservation.statusId === ReservationStatus.CancelPending || quote.reservation.statusId === ReservationStatus.CancelComplete) && iu.showOnItinerary) || !iu.cancelled && iu.showOnItinerary)))) && (
                          <>
                            <h4
                              className="itinerary-font"
                              style={{ color: style.headerColor }}
                            >
                              Extras
                          </h4>
                            <Row
                              style={{
                                borderBottom: "2px solid",
                                borderColor: style.borderColor,
                              }}
                            />
                          </>
                        )}

                        {/* Extra items */}
                        {/* {itinerary.customItineraries && itinerary.customItineraries.map((customItinerary: CustomItinerary) => customItinerary.itineraryUnits.map((item: CustomItineraryUnit, index: number) => ( */}
                        {itinerary.customItineraries && itinerary.customItineraries.flatMap(i => i.itineraryUnits).filter(u => quote === undefined || quote.reservation.statusId === ReservationStatus.CancelPending || quote.reservation.statusId === ReservationStatus.CancelComplete || !u.cancelled)
                          .sort((a, b) => {
                            const dateA = moment(a.startDate);
                            const dateB = moment(b.startDate);

                            if (dateA.isBefore(dateB)) return -1;
                            if (dateA.isAfter(dateB)) return 1;
                            if (a.startTime !== undefined && b.startTime !== undefined) {
                              if (a.startTime < b.startTime) return -1;
                              if (a.startTime > b.startTime) return 1;
                            }
                            return 0;
                          })
                          .map((item: CustomItineraryUnit, index: number) => {
                            item.itineraryIndex = index;
                            return item;
                          })
                          .map((item: CustomItineraryUnit, index: number) => (
                            <CustomItemTab
                              key={`Custom tab ${item.vendorId}-${index}`}
                              itinerary={itinerary}
                              vendor={item.vendor as CustomItem}
                              itemIndex={index}
                              item={item}
                              removeItem={removeCustomItem}
                              editItem={(unit: CustomItineraryUnit) => {
                                // unit.vendor.itineraryIndex = index;
                                onEditCustom(unit);
                                setShow("add-custom");
                              }}
                              bookNowRequested={bookNowRequested}
                              quoteRequested={quoteRequested}
                              datesAndGuests={datesAndGuests}
                              quoteStatus={quote && quote.reservation.statusId ? quote.reservation.statusId : undefined}
                              onVendorImageClick={(vendor: Vendor | undefined) => {
                                setSelectedVendor(vendor);
                                setShowModal("vendor-images");
                              }}
                              editable={pbPackage === undefined ? quote === undefined : quote === undefined && pbPackage.allowCustomization}
                            />
                          ))}

                        {/* Add Extras Button */}
                        {webViewAddButtonConditional && (
                          <AddItineraryUnitButton
                            buttonText="+ Add Extras"
                            onClick={() => {
                              setShow("add-custom");
                            }}
                          />
                        )}
                      </div>
                    </>
                  )}
                </>
              )}


              {/* Adjustments */}
              {((itinerary.adjustments && itinerary.adjustments.length > 0)) && (
                <>
                  {true && (true || (true)) && (
                    <>
                      <div className="mt-3">
                        {(!!quote || (itinerary.adjustments && itinerary.adjustments.some((ad: Adjustment) => ad.showOnItinerary))) && (
                          <>
                            <h4
                              className="itinerary-font"
                              style={{ color: style.headerColor }}
                            >
                              Adjustments
                          </h4>
                            <Row
                              style={{
                                borderBottom: "2px solid",
                                borderColor: style.borderColor,
                              }}
                            />
                          </>
                        )}

                        {itinerary.adjustments && itinerary.adjustments.map((adjustment: Adjustment) =>
                          <AdjustmentTab
                            item={adjustment}
                            quoteStatus={quote && quote.reservation.statusId ? quote.reservation.statusId : undefined}
                          />
                        )}
                      </div>
                    </>
                  )}
                </>
              )}

              {(!!!quote && viewPortBreakPoint >= ViewPort.md) && (
                <div style={{marginTop: '3rem'}}>
                  <Row
                    style={{
                      borderBottom: "2px solid",
                      borderColor: style.borderColor,
                    }}
                  />
                  { /* if allow promocode use */}
                  {(pbPackage === undefined ? brandSetting.allowPromoCodeUse : pbPackage.allowPromoCodeUse) && (
                    <Row className="w-100 m-0 p-0 mt-3">
                      <Form.Group className="m-0 p-0 ml-auto mr-0" as={Col} xs={3}>
                        <InputGroup>
                          {promo !== undefined && (
                            <InputGroup.Prepend>
                              <Button variant="success" onClick={() => {
                                // handleDeletePromoEntry();
                              }}><i className="fas fa-check"></i></Button>
                            </InputGroup.Prepend>
                          )}

                          <Form.Control
                            placeholder="Promo Code"
                            style={{ borderTopRightRadius: '5px', borderBottomRightRadius: '5px' }}
                            name={`Promocode`}
                            // ref={register}
                            disabled={promo !== undefined}
                            value={promoInput}
                            onChange={e => {
                              setPromoInput(e.target.value);
                            }}
                          />
                          {promo === undefined && (
                            <Button className="ml-2" variant="info" onClick={() => handlePromoEntry()}>
                              {promoFetchResponse.isLoading ? (
                                <span><Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                /></span>
                              ) : (
                                  <span>Apply</span>
                                )}
                            </Button>
                          )}
                        </InputGroup>
                        {promo !== undefined && (
                          <Form.Group as={Col} xs={12} md={{ span: 6, offset: 6 }} className="d-flex pb-0 mb-0">
                            <small id="successMsg" className="green-text" >Promo Code applied!</small>
                          </Form.Group>
                        )}
                        {promoError && (
                          <Form.Group as={Col} xs={12} md={{ span: 6, offset: 6 }} className="d-flex pb-0 mb-0">
                            <small id="errorMsg" className="text-danger" >{promoErrorMsg}</small>
                          </Form.Group>
                        )}
                      </Form.Group>
                    </Row>
                  )}

                  <Row className="w-100 m-0 p-0 mt-3">
                    <Form.Group className="m-0 p-0 ml-auto mr-0" as={Col} xs={3}>
                      <div className="w-100 d-flex flex-row justify-content-between">
                        {startWidget.showBookNowButton && (
                          <Button
                            // className="ml-auto mr-0"
                            disabled={isQuoteExpired}
                            style={{
                              backgroundColor: style.bookNowButtonColor,
                              border: "none",
                            }}
                            onClick={() => {
                              let allowLodging = true;
                              if (brandSetting !== undefined) {
                                let nights = 0;

                                if (itinerary.lodgingItineraries !== undefined) {
                                  itinerary.lodgingItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                                    if (!allowLodging) return;

                                    const start = moment(u.startDate);
                                    const end = moment(u.endDate);
                                    nights = end.diff(start, "days");

                                    if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber) {
                                      allowLodging = false;
                                    }
                                  }));
                                }

                                if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber)
                                  allowLodging = false;
                              }

                              let missingRate = false;;
                              let golfCount = 0;

                              if (itinerary.golfItineraries !== undefined) {
                                itinerary.golfItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                                  ++golfCount;
                                  if (u.availableTimes.length === 0) {
                                    missingRate = true;
                                  }
                                }))
                              }

                              if (!allowLodging) {
                                setShowModal("lodging-nights-required");
                                return;
                              }

                              if (missingRate) {
                                setShowModal("missing-rate");
                                return;
                              }

                              if (brandSetting.requireGolfItems && golfCount < brandSetting.golfItemsRequiredNumber) {
                                setShowModal("golf-items-required");
                                return;
                              }

                              setShowModal("book-now");
                            }}
                          >
                            Book Now
                          </Button>
                        )}

                        {startWidget.showSaveQuoteButton && (
                          <Button
                            // className="ml-3 mr-0"
                            className="ml-auto mr-0"
                            style={{
                              backgroundColor: style.getQuoteButtonColor,
                              border: "none",
                            }}
                            onClick={() => {
                              let allowLodging = true;
                              if (brandSetting !== undefined) {
                                let nights = 0;

                                if (itinerary.lodgingItineraries !== undefined) {
                                  itinerary.lodgingItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                                    if (!allowLodging) return;

                                    const start = moment(u.startDate);
                                    const end = moment(u.endDate);
                                    nights = end.diff(start, "days");

                                    if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber) {
                                      allowLodging = false;
                                    }
                                  }));
                                }

                                if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber)
                                  allowLodging = false;
                              }

                              let missingRate = false;;
                              let golfCount = 0;

                              if (itinerary.golfItineraries !== undefined) {
                                itinerary.golfItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                                  ++golfCount;
                                  if (u.availableTimes.length === 0) {
                                    missingRate = true;
                                  }
                                }))
                              }

                              if (!allowLodging) {
                                setShowModal("lodging-nights-required");
                                return;
                              }

                              if (missingRate) {
                                setShowModal("missing-rate");
                                return;
                              }

                              if (brandSetting.requireGolfItems && golfCount < brandSetting.golfItemsRequiredNumber) {
                                setShowModal("golf-items-required");
                                return;
                              }

                              setShowModal("get-quote");
                            }}
                          >
                            Save/Get Quote
                          </Button>
                        )}
                      </div>
                    </Form.Group>
                  </Row>
                </div>
              )}
            </div>

            {/* Mobile Book Now & Get Quote Button */}
            {!!!quote && viewPortBreakPoint < ViewPort.md && (
              <>
                {pbPackage === undefined ? brandSetting.allowPromoCodeUse : pbPackage.allowPromoCodeUse && (
                  <>
                    <Row className="w-100 mt-3">
                      <Form.Group className="ml-auto mr-0" as={Col} xs={8}>
                        <InputGroup>
                          {promo !== undefined && (
                            <InputGroup.Prepend>
                              <Button variant="success" onClick={() => {
                                // handleDeletePromoEntry();
                              }}><i className="fas fa-check"></i></Button>
                            </InputGroup.Prepend>
                          )}

                          <Form.Control
                            placeholder="Promo Code"
                            style={{ borderTopRightRadius: '5px', borderBottomRightRadius: '5px' }}
                            name={`Promocode`}
                            // ref={register}
                            value={promoInput}
                            disabled={promo !== undefined}
                            onChange={e => {
                              setPromoInput(e.target.value);
                            }}
                          />
                          {promo === undefined && (
                            <Button className="ml-2" variant="info" onClick={() => handlePromoEntry()}>
                              {promoFetchResponse.isLoading ? (
                                <span><Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                /></span>
                              ) : (
                                  <span>Apply</span>
                                )}
                            </Button>
                          )}
                        </InputGroup>
                        {promo !== undefined && (
                          <Form.Group as={Col} xs={12} md={{ span: 6, offset: 6 }} className="d-flex pb-0 mb-0">
                            <small id="successMsg" className="green-text" >Promo Code applied!</small>
                          </Form.Group>
                        )}
                        {promoError && (
                          <Form.Group as={Col} xs={12} md={{ span: 6, offset: 6 }} className="d-flex pb-0 mb-0">
                            <small id="errorMsg" className="text-danger" >{promoErrorMsg}</small>
                          </Form.Group>
                        )}
                      </Form.Group>
                    </Row>
                  </>
                )}

                <Row className="w-100 mt-3">
                  {startWidget.showBookNowButton && (
                    <Col xs={(startWidget.showSaveQuoteButton ? 6 : 12)} className="mobile-form-buttons">
                      <Button
                        disabled={isQuoteExpired}
                        className=""
                        style={{
                          backgroundColor: style.bookNowButtonColor,
                          border: "none",
                          width: "100%",
                        }}
                        onClick={() => {
                          let allowLodging = true;
                          if (brandSetting !== undefined) {
                            let nights = 0;

                            if (itinerary.lodgingItineraries !== undefined) {
                              itinerary.lodgingItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                                if (!allowLodging) return;

                                const start = moment(u.startDate);
                                const end = moment(u.endDate);
                                nights = end.diff(start, "days");

                                if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber) {
                                  allowLodging = false;
                                }
                              }));
                            }

                            if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber)
                              allowLodging = false;
                          }

                          let missingRate = false;;
                          let golfCount = 0;

                          if (itinerary.golfItineraries !== undefined) {
                            itinerary.golfItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                              ++golfCount;
                              if (u.availableTimes.length === 0) {
                                missingRate = true;
                              }
                            }))
                          }

                          if (!allowLodging) {
                            setShowModal("lodging-nights-required");
                            return;
                          }

                          if (missingRate) {
                            setShowModal("missing-rate");
                            return;
                          }

                          if (brandSetting.requireGolfItems && golfCount < brandSetting.golfItemsRequiredNumber) {
                            setShowModal("golf-items-required");
                            return;
                          }

                          setShowModal("book-now");
                        }}
                      >
                        Book Now
                  </Button>
                    </Col>
                  )}

                  {startWidget.showSaveQuoteButton && (
                    <Col xs={(startWidget.showBookNowButton ? 6 : 12)} className="mobile-form-buttons">
                      <Button
                        style={{
                          backgroundColor: style.getQuoteButtonColor,
                          border: "none",
                          width: "100%",
                        }}
                        onClick={() => {
                          let allowLodging = true;
                          if (brandSetting !== undefined) {
                            let nights = 0;

                            if (itinerary.lodgingItineraries !== undefined) {
                              itinerary.lodgingItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                                if (!allowLodging) return;

                                const start = moment(u.startDate);
                                const end = moment(u.endDate);
                                nights = end.diff(start, "days");

                                if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber) {
                                  allowLodging = false;
                                }
                              }));
                            }

                            if (brandSetting.requireLodgingNights && nights < brandSetting.lodgingNightsRequiredNumber)
                              allowLodging = false;
                          }

                          let missingRate = false;;
                          let golfCount = 0;

                          if (itinerary.golfItineraries !== undefined) {
                            itinerary.golfItineraries.forEach(i => i.itineraryUnits.forEach(u => {
                              ++golfCount;
                              if (u.availableTimes.length === 0) {
                                missingRate = true;
                              }
                            }))
                          }

                          if (!allowLodging) {
                            setShowModal("lodging-nights-required");
                            return;
                          }

                          if (missingRate) {
                            setShowModal("missing-rate");
                            return;
                          }

                          if (brandSetting.requireGolfItems && golfCount < brandSetting.golfItemsRequiredNumber) {
                            setShowModal("golf-items-required");
                            return;
                          }

                          setShowModal("get-quote");
                        }}
                      >
                        Save/Get Quote
                    </Button>
                    </Col>
                  )}
                </Row>
              </>
            )}

            {/* Totals */}
            {quote && quote.reservation.statusId && (Number)(quote.reservation.statusId) !== 40 && (Number)(quote.reservation.statusId) !== 50 && (
              <Totals
                quote={quote}
                setShowModal={setShowModal}
                onReservationCustomerAdded={onReservationCustomerAdded}
                onPayClicked={(customer: ReservationCustomer) => displayPaymentModalForCustomer(customer)}
                emailCustomer={emailCustomer}
                handleUseIndividualPayments={handleIndividualPayments}
                isQuoteExpired={isQuoteExpired}
                allowPromo={pbPackage === undefined ? brandSetting.allowPromoCodeUse : pbPackage.allowPromoCodeUse}
              />
            )}

            {startWidget.showBookNowButton && quote && quote.reservation.statusId !== 40 && quote.reservation.statusId !== 50 && viewPortBreakPoint < ViewPort.md && (quote.reservation.paymentCategories === undefined || quote.reservation.paymentCategories.length === 0) && (
              <Row className="w-100">
                <Col xs={12} className="mobile-form-buttons">
                  <Button
                    disabled={isQuoteExpired}
                    style={{
                      backgroundColor: style.bookNowButtonColor,
                      border: "none",
                      width: "100%",
                      marginTop: "25px"
                    }}
                    onClick={() => {
                      setShowModal("make-payment");
                    }}
                  >
                    Book Now
                </Button>
                </Col>
              </Row>
            )}
          </Col>
        )
      }

      {/* Get Quote Modal */}
      <Modal
        scrollable={true}
        size="lg"
        show={showModal === "get-quote"}
        onHide={() => setShowModal("")}
        backdropClassName="white-overlay"
        dialogClassName="box-shadow mobile-full-width"
      >
        <Modal.Header
          translate
          closeButton
          style={{
            border: "none",
            borderBottom: "1px solid rgb(222,222,222)",
          }}
        >
          <div className="w-100">
            <Modal.Title className="font-weight-bold" style={{ color: style.fontColor }}>Get Quote</Modal.Title>
            {/* <Row className="m-0 p-0">
                <p className="itinerary-info mr-2 my-0"><span><i className="far fa-calendar-alt"></i></span> {datesAndGuests.fromDate ? datesAndGuests.fromDate.toDateString() : "Arrive"}</p>
                <p className="itinerary-info my-0"> - </p>
                <p className="itinerary-info ml-2 my-0 mr-5"><span><i className="far fa-calendar-alt"></i></span> {datesAndGuests.toDate ? datesAndGuests.toDate.toDateString() : "Depart"}</p>
                <p className="itinerary-info m-0 p-0"><span className="font-weight-bold">{datesAndGuests.guests}</span>{` Guest${datesAndGuests.guests > 1 ? "s" : ""}`}</p>
              </Row> */}
          </div>
        </Modal.Header>
        <Modal.Body>
          {/* Get Quote */}
          <GetQuote
            // datesAndGuests={datesAndGuests}
            requestItineraryQuote={requestItineraryQuote}
            isLoading={createResponse.isLoading}
          />
        </Modal.Body>
      </Modal>

      {/* Make Payment Modal */}
      {quote && quote.reservation.statusId !== 40 && quote.reservation.statusId !== 50 && (
        <Modal
          scrollable={true}
          size="lg"
          show={showModal === "make-payment"}
          onHide={() => {
            setShowModal("");
            setPayingCustomer(undefined);
          }}
          backdropClassName="white-overlay"
          dialogClassName="box-shadow mobile-full-width"
        >
          <Modal.Header
            closeButton
            translate
            style={{
              border: "none",
              borderBottom: "1px solid rgb(222,222,222)",
            }}
          >
            <Modal.Title
              id="example-modal-sizes-title-lg"
              style={{ fontWeight: "bold", color: "green" }}
            >
              Make A Payment
                </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Make Payment */}
            <MakePayment
              quote={quote}
              payingCustomer={payingCustomer}
              onPaymentMade={(data: any) => {
                // console.log("payment made", data);
                setShowModal("");
                setPayingCustomer(undefined);
                //need to reload the quote
                toast.success("Payment Successful!", { hideProgressBar: false });
                if (quote.campaignId !== undefined) {
                  if (startWidget.activateGoogleAnalytics && !isStringEmpty(startWidget.googleAnalyticsTrackingCode)) {
                    ReactGA.event({
                      category: "PKGLoop_Custom",
                      action: "PKGLoop_PaymentSuccess",
                      label: startWidget.brandId.toString(),
                      value: data.amount, // amount paid
                    });
                    // consume the localStorage flag
                    window.localStorage.removeItem("isAdConversion");
                  }
                }

                setTimeout(function () {
                  if (!window.location.href.includes("&itineraryNumber="))
                    window.location.href += `&itineraryNumber=${quote.reservation.itineraryNumber}`;
                  else window.location.reload();
                }, 2000);
              }}
              onError={(error: any) => {
                console.log("payment error", error);
                toast.error(`Payment Error! - ${error.error}`, { hideProgressBar: false });

                setShowModal("");
                setPayingCustomer(undefined);

                // setTimeout(function () {
                //   if (!window.location.href.includes("&itineraryNumber="))
                //     window.location.href += `&itineraryNumber=${quote.reservation.itineraryNumber}`;
                //   else window.location.reload();
                // }, 2000);
              }}
            />
          </Modal.Body>
        </Modal>
      )}

      <Modal
        scrollable={true}
        size="lg"
        show={showModal === "book-now"}
        onHide={() => {
          setShowModal("");
          // setPayingCustomer(undefined);
        }}
        backdropClassName="white-overlay"
        dialogClassName="box-shadow mobile-full-width"
      >
        <Modal.Header
          closeButton
          translate
          style={{
            border: "none",
            borderBottom: "1px solid rgb(222,222,222)",
          }}
        >
          <Modal.Title
            id="example-modal-sizes-title-lg"
            style={{ fontWeight: "bold", color: "green" }}
          >
            Book Now
              </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Make Payment */}
          <BookNow
            quote={quote}
            itinerary={itinerary}
            dateAndGuests={datesAndGuests}
            requestItineraryQuote={requestItineraryQuote}
            createdFromBooking={createdFromBooking}
            onPaymentMade={(data: any) => {
              setShowModal("");
              setPayingCustomer(undefined);
              //need to reload the quote
              if (quote !== undefined) {
                toast.success("Payment Successful!", { hideProgressBar: false });
                if (quote.campaignId !== undefined) {
                  if (startWidget.activateGoogleAnalytics && !isStringEmpty(startWidget.googleAnalyticsTrackingCode)) {
                    ReactGA.event({
                      category: "PKGLoop_Custom",
                      action: "PKGLoop_PaymentSuccess",
                      label: startWidget.brandId.toString(),
                      value: data.amount, // amount paid
                    });
                    // consume the localStorage flag
                    window.localStorage.removeItem("isAdConversion");
                  }
                }

                setTimeout(function () {
                  if (!window.location.href.includes("&itineraryNumber="))
                    window.location.href += `&itineraryNumber=${quote.reservation.itineraryNumber}`;
                  else window.location.reload();
                }, 2000);

                if (quote.reservation.payments === undefined) {
                  quote.reservation.payments = [];
                  quote.reservation.statusId = 20;
                }

                quote.reservation.payments.push({
                  paymentId: 0,
                  reservationId: quote.reservation.reservationId as number,
                  paymentDate: new Date().toString(),
                  customerId: data.customerId,
                  paymentAmount: data.amount,
                  createdOn: "",
                  ccExpiration: "",
                  ccNumber: "",
                  paymentType: 0,
                  paymentTypeId: 0,
                  status: "Pending",
                  tipAmount: data.tipAmount
                });

                quote.reservation.balanceDue = (quote.reservation.balanceDue as number) - (data.amount - data.tipAmount);

                setQuote(JSON.parse(JSON.stringify(quote)));
              }
            }}
            onError={(error: any) => {
              console.log("payment error", error);
              toast.error(`Payment Error! - ${error.error}`, { hideProgressBar: false });

              setShowModal("");
              setPayingCustomer(undefined);
            }}
          />
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={showModal === "lodging-required"}
        onHide={() => {
          setShowModal("");
        }}
        backdropClassName="white-overlay"
        dialogClassName="box-shadow mobile-full-width"
      >
        <Modal.Header
          translate
          closeButton
          style={{
            border: "none",
            borderBottom: "1px solid rgb(222,222,222)",
          }}
        >
          <Modal.Title
            id="example-modal-sizes-title-lg"
            style={{ fontWeight: "bold", color: "green" }}
          >
            Lodging Required
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Please select Lodging before requesting a quote.</p>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={showModal === "missing-rate"}
        onHide={() => {
          setShowModal("");
        }}
        backdropClassName="white-overlay"
        dialogClassName="box-shadow mobile-full-width"
      >
        <Modal.Header
          translate
          closeButton
          style={{
            border: "none",
            borderBottom: "1px solid rgb(222,222,222)",
          }}
        >
          <Modal.Title
            id="example-modal-sizes-title-lg"
            style={{ fontWeight: "bold", color: "green" }}
          >
            Unavailable Tee Time
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>One or more golf items is unavailable on the specific date chosen, please select a new date and time.</p>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={showModal === "lodging-nights-required"}
        onHide={() => {
          setShowModal("");
        }}
        backdropClassName="white-overlay"
        dialogClassName="box-shadow mobile-full-width"
      >
        <Modal.Header
          translate
          closeButton
          style={{
            border: "none",
            borderBottom: "1px solid rgb(222,222,222)",
          }}
        >
          <Modal.Title
            id="example-modal-sizes-title-lg"
            style={{ fontWeight: "bold", color: "green" }}
          >
            Lodging Nights Required
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{`Please select Lodging with a minimum of ${brandSetting.lodgingNightsRequiredNumber} nights before requesting a quote.`}</p>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={showModal === "golf-items-required"}
        onHide={() => {
          setShowModal("");
        }}
        backdropClassName="white-overlay"
        dialogClassName="box-shadow mobile-full-width"
      >
        <Modal.Header
          translate
          closeButton
          style={{
            border: "none",
            borderBottom: "1px solid rgb(222,222,222)",
          }}
        >
          <Modal.Title
            id="example-modal-sizes-title-lg"
            style={{ fontWeight: "bold", color: "green" }}
          >
            Golf Rounds Required
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{`Please select a minimum of ${brandSetting.golfItemsRequiredNumber} Golf rounds before requesting a quote.`}</p>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={showModal === "missing-rate"}
        onHide={() => {
          setShowModal("");
        }}
        backdropClassName="white-overlay"
        dialogClassName="box-shadow mobile-full-width"
      >
        <Modal.Header
          translate
          closeButton
          style={{
            border: "none",
            borderBottom: "1px solid rgb(222,222,222)",
          }}
        >
          <Modal.Title
            id="example-modal-sizes-title-lg"
            style={{ fontWeight: "bold", color: "green" }}
          >
            Unavailable Tee Time
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>One or more golf items is unavailable on the specific date chosen, please select a new date and time.</p>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={showModal === "vendor-images"}
        onHide={() => {
          setShowModal("");
        }}
        backdropClassName="white-overlay"
        dialogClassName="box-shadow mobile-full-width"
      >
        {/* <Modal.Header
          translate
          closeButton
          style={{
            border: "none",
            borderBottom: "1px solid rgb(222,222,222)",
          }}
        >
          <Modal.Title
            id="example-modal-sizes-title-lg"
            style={{ fontWeight: "bold", color: "green" }}
          >
            Lodging Required
          </Modal.Title>
        </Modal.Header> */}
        <Modal.Body>
          <Carousel activeIndex={imgIndex} onSelect={handleSelect} indicators={false}
            style={{
              backgroundColor: "#F7F7F7",
            }}
          >
            {/* Vendor Units has images now */}
            {selectedVendor !== undefined && selectedVendor.vendorUnits && selectedVendor.vendorUnits.some(u => u.vendorUnitImages.length > 0) &&
              selectedVendor.vendorUnits.map((unit: VendorUnit) => {
                return unit.vendorUnitImages.map((image: VendorUnitImage, index: number) => {
                  return (<Carousel.Item
                    key={`${unit.unitName}-${unit.vendorUnitId}-${index}`}
                    style={{
                      height: "600px",
                      backgroundColor: "#F7F7F7",
                    }}
                  >
                    <img
                      className="d-block w-100"
                      src={image.imageUrl}
                      alt={image.name}
                    />
                    <Carousel.Caption>
                      <p>{image.description}</p>
                    </Carousel.Caption>
                  </Carousel.Item>
                  )
                })
              })
            }

            {selectedVendor !== undefined && selectedVendor.vendorUnits && !selectedVendor.vendorUnits.some(u => u.vendorUnitImages.length > 0) && (
              <img
                className="d-block w-100"
                style={{
                  height: "600px",
                  backgroundColor: "#F7F7F7",
                }}
                src={""}
                alt={""}
              />
            )}
          </Carousel>
        </Modal.Body>
      </Modal>
    </React.Fragment >
  );
}

export default ItineraryStart;